// Store toàn cục cho job "Cắt highlight" chạy ngầm.
// - Lưu localStorage → sống qua reload / tắt-mở app cho tới khi user bấm "Thoát".
// - Pub-sub qua useSyncExternalStore (cache tham chiếu ổn định) + lắng nghe
//   'storage' event để đồng bộ đa tab.
// Mỗi job: { id, title, filename, autoMode, status, progress, download_url,
//            ts, hidden, downloaded }
//   status: processing | ready | failed | cancelled
//   hidden: true khi user "Thoát" lúc còn đang cắt (thu gọn tạm; job xong sẽ
//           tự hiện lại để mời tải).
const KEY = "pl_clip_jobs";
const TTL_MS = 24 * 60 * 60 * 1000;
export const MAX_ACTIVE_JOBS = 3;

const listeners = new Set();
let _cache = null;

function _rawRead() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || "[]");
    if (!Array.isArray(raw)) return [];
    const now = Date.now();
    return raw.filter((j) => j && j.id && now - (j.ts || 0) < TTL_MS);
  } catch {
    return [];
  }
}

function _write(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    /* noop */
  }
  _cache = list;
  listeners.forEach((cb) => {
    try { cb(); } catch { /* noop */ }
  });
}

// getSnapshot cho useSyncExternalStore — trả tham chiếu ổn định.
export function getJobs() {
  if (_cache == null) _cache = _rawRead();
  return _cache;
}

export function subscribe(cb) {
  listeners.add(cb);
  const onStorage = (e) => {
    if (e.key === KEY) { _cache = _rawRead(); cb(); }
  };
  window.addEventListener("storage", onStorage);
  return () => {
    listeners.delete(cb);
    window.removeEventListener("storage", onStorage);
  };
}

export function activeCount() {
  return getJobs().filter((j) => j.status === "processing").length;
}

export function addJob({ id, title, filename, autoMode }) {
  if (!id) return;
  const list = getJobs().filter((j) => j.id !== id);
  list.push({
    id,
    title: title || "Highlight",
    filename: filename || "highlight",
    autoMode: !!autoMode,
    status: "processing",
    progress: 3,
    download_url: null,
    ts: Date.now(),
    hidden: false,
    downloaded: false,
  });
  _write(list);
}

export function updateJob(id, patch) {
  let changed = false;
  const list = getJobs().map((j) => {
    if (j.id !== id) return j;
    changed = true;
    return { ...j, ...patch };
  });
  if (changed) _write(list);
}

export function removeJob(id) {
  _write(getJobs().filter((j) => j.id !== id));
}
